module.exports = __webpack_public_path__ + "static/img/4.4f4f89f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/sp/4.png
// module id = 42Ja
// module chunks = 0